import { Control, Controller } from 'react-hook-form'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { useCountries } from '@/hooks/useCountries'

import { ParticipantFormValues } from '../ParticipantForm/StandaloneParticipantForm'

export interface CountrySelectProps {
  control: Control<ParticipantFormValues>
  prefix: 'customer' | 'beneficiary' | 'supplier'
  // name: string
  // defltValue?: string
}

export const CountrySelect =(
  props: CountrySelectProps,
) => {
  const countries = useCountries()

  // const coll = createListCollection({
  const coll = countries.map((country) => ({
    label: country.name,
    value: country.code,
  }))
  // })

  return (
    <Controller
      control={props.control}
      name={`${props.prefix}.address.country`}
      render={({ field }) => {
        return (
          <Select
            // variant="outline"
            // css={{ ...css }}
            // {...props}
            // name={field.name}
            {...field}
            value={field.value!}
            onValueChange={(value) => {
              field.onChange(value)
            }}
            // collection={coll}
          >
            {/* <Select.HiddenSelect /> */}

            <SelectTrigger className="w-full max-w-full">
              <SelectValue placeholder="Země" />
            </SelectTrigger>

            <SelectContent>
              {coll.map((country) => (
                <SelectItem value={country.value} key={country.value}>
                  {country.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        )
      }}
    />
  )
}

CountrySelect.displayName = 'CountrySelect'
